export default __webpack_public_path__ + "static/media/Roboto-Bold.9fa4a811.woff";